module.exports = new __parcel__URL__("coleccionable.e7910b5a.png").toString();